/** Form.io submit-button rows are not useful in the grid or PDF export. */
export const EXCLUDED_SUBMISSION_DATA_KEYS = new Set(['submit']);

export const FORM_SUBMISSIONS_PAGE_SIZE = 25;

/**
 * Guard for `useParams().formId` before issuing submission API requests.
 * @param {unknown} formId
 * @returns {boolean}
 */
export const isFormIdPresent = (formId) => {
  if (formId == null) {
    return false;
  }
  if (typeof formId !== 'string' && typeof formId !== 'number') {
    return false;
  }
  return String(formId).trim() !== '';
};

/** Matches Feeds Audit `createdAt` column (`getBaseAuditColumns` in Audit.service.js) for DataGrid date-range filter. */
export const SUBMITTED_AT_DATE_FILTER_FORMAT = 'M/dd/yyyy';

/** Moment format for Form.io datetime answers in submissions grid and CSV (24-hour clock). */
export const FORM_SUBMISSION_DATETIME_DISPLAY_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

/**
 * Row key holding ISO-ish `created_at` for client-side date-range filtering (not shown as a column).
 * @type {string}
 */
export const SUBMITTED_AT_RAW_ROW_KEY = 'submitted_at_raw';
